import $ from 'jquery';

export default class {

    $get () {
        return $;
    }

}



// WEBPACK FOOTER //
// ./src/app/providers/$/index.js